/**
 * Returns an album or album folder linked to the video. It will prioritize will go in the following manner:
 * 1. Album
 * 2. Root album folder
 * 3. Whatever link we have left.
 *
 * @param {Object} videoRecord The video record to get the entity from.
 * @returns {Object} The album or albumFolder linked. Undefined if video is not linked
 */
export const getVideoEntityFromLinks = videoRecord => {
  const videoLinks = videoRecord?.video_links?.records ?? [];
  const albumLink = videoLinks.find(videoLink => !!videoLink.album?.id);

  if (albumLink) {
    return albumLink.album;
  }

  const rootAlbumFolderLink = videoLinks.find(
    videoLink => !!videoLink.album_folder?.id && videoLink.album_folder.is_root,
  );

  if (rootAlbumFolderLink) {
    return rootAlbumFolderLink.album_folder;
  }

  return videoLinks[0]?.album_folder;
};
